// extracted by mini-css-extract-plugin
export default {"basicSingle":"sfN2X4kLywE6lSpYN0Ak"};